/**
 * Single source of truth for character extraction. The transform `slice` op and
 * the formula LEFT/RIGHT/MID functions all delegate here so they cannot drift.
 * 0-based, end-exclusive (JS String.prototype.slice semantics). Preserves the
 * shipped transform behavior: start >= length returns "".
 */
export function sliceChars(input, start0, endExcl) {
    const s = String(input ?? '');
    if (start0 >= s.length)
        return '';
    return s.slice(start0, endExcl);
}
/** 1-based index of first occurrence; 0 if absent or either side null. */
export function findIndex1(input, needle) {
    if (input === null || input === undefined)
        return 0;
    if (needle === null || needle === undefined)
        return 0;
    const idx = String(input).indexOf(String(needle));
    return idx < 0 ? 0 : idx + 1;
}
/** Replace ALL occurrences literally (no regex). null in -> null out. */
export function replaceAllLiteral(input, find, repl) {
    if (input === null || input === undefined)
        return null;
    const s = String(input);
    const f = String(find ?? '');
    if (f === '')
        return s;
    return s.split(f).join(String(repl ?? ''));
}
//# sourceMappingURL=string-core.js.map